jQuery(document).ready(function(){
	
	jQuery('body').addClass('loaded');
	
});


jQuery( ".mobile-toggle button" ).click(function() {
	
  jQuery( ".top-nav" ).toggleClass( 'menu-open' );
  
});

jQuery( "button.expand" ).click(function() {
	
  jQuery( this ).prev().toggleClass( 'expanded' );
    
  if( jQuery(this).prev().hasClass('expanded') ) {
	  
	  jQuery(this).children('span').text('View Less');
	  
  }
  
  else {
	
	jQuery(this).children('span').text('View More');
	
	jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery(".search-tools").offset().top - 100
    }, 500);
	  
  }
  
  window.dispatchEvent(new Event('resize'));
  
});

jQuery(document).ready(function(){
	
	var path = document.querySelector("#bg_lines path");
	var total_length = path.getTotalLength();
	
//	jQuery('#bg_lines path').css( 'stroke-dasharray', total_length );
	jQuery('#bg_lines path').css( 'stroke-dashoffset', total_length );
	
	
});


jQuery(".edit-profile").click(function() {
  jQuery("html, body").animate({ scrollTop: 0 }, "slow");
  //return false;
});

jQuery(".mobile-results").click(function() {
 jQuery([document.documentElement, document.body]).animate({
        scrollTop: jQuery("#results").offset().top - 100
    }, 500);
  //return false;
});